export default "__VITE_ASSET__DL3ECH3Y__"